import request from '@/utils/http';
const API_TRANSPORT = 'api-antms/transport';

// 打印模板匹配接口
export const queryTemplate = data => {
    return request({
        url: `/api-antms/common/print/template/config/match`,
        method: 'post',
        data
    });
};

// 打印模板批量匹配接口
export const batchQueryTemplate = data => {
    return request({
        url: `api-antms/common/print/template/config/matchBatchs`,
        method: 'post',
        data
    });
};

// 新打印接口
export const dispatchPrint = data => {
    return request({
        url: `${API_TRANSPORT}/print/dispatch/new`,
        method: 'post',
        data
    });
};

// 批量打印接口
export const dispatchBatchPrint = data => {
    return request({
        url: `api-antms/common/print/dispatch/newBatch`,
        method: 'post',
        data
    });
};

// 更新打印次数
export const updatePrintCount = data => {
    return request({
        url: `${API_TRANSPORT}/print/dispatch/updateTimes`,
        method: 'post',
        data
    });
};

// 批量更新打印次数
export const batchUpdatePrintCount = data => {
    return request({
        url: `api-antms/common/print/dispatch/updateTimesBatch`,
        method: 'post',
        data
    });
};

export const checkPrintCount = data => {
    return request({
        url: `${API_TRANSPORT}/print/dispatch/times`,
        method: 'get',
        params: data
    });
};

// 批量查询是否首次打印
export const batchCheckPrintCount = data => {
    return request({
        url: `api-antms/common/print/dispatch/timesBatch`,
        method: 'post',
        data
    });
};

export const queryCompanyConfig = data => {
    return request({
        url: `api-antms/common/print/company/apollo/config`,
        method: 'post',
        data
    });
};

// 打印预览-命中情况
export const queryMatchDetail = data => {
    return request({
        url: `api-antms/common/print/template/match/detail`,
        method: 'post',
        data
    });
};
// 打印预览-命中规则
export const queryMatchRules = data => {
    return request({
        url: `api-antms/common/print/template/config/detail`,
        method: 'get',
        params: data
    });
};

// 打印预览-样图预览
export const queryTemplateDetail = data => {
    return request({
        url: `api-antms/common/print/template/config/queryList`,
        method: 'post',
        data
    });
};
